import en from './en.js';
import ru from './ru.js';
import pt from './pt.js';

export default {
  au: en,
  ru: ru,
  br: pt,
  us: en,
  de: en,
  uk: en,
  ca: en,
  it: en,
  nz: en,
};